import { TextField } from "final-form-material-ui";
import React, { useCallback } from "react";
import BaseField from "./BaseField";
import msk from "msk";

const SimpleTextField = ({ maskPattern, ...props }) => {
  const mask = useCallback(value => msk.fit(value, maskPattern), [maskPattern]);

  const handleKeyDown = event => {
    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      event.preventDefault();
      event.stopPropagation();
    }

    if (props.onKeyDown) {
      props.onKeyDown(event);
    }
  };

  return (
    <BaseField
      component={TextField}
      parse={maskPattern ? mask : undefined}
      {...props}
      onKeyDown={handleKeyDown}
    />
  );
};

export default SimpleTextField;
